import type { LastActiveContext } from "src/common/utils/lastActiveContext.js";
import { useProfilePreference } from "src/common/utils/hooks/useProfilePreference.js";

export const useLastActiveContext = () => {
	const [value, setValue] = useProfilePreference<LastActiveContext | null>(
		"lastActiveContext",
		null,
	);

	return {
		value: value ?? undefined,
		write: (context: LastActiveContext) => setValue(context),
		clear: () => setValue(null),
	};
};
